import React from 'react';
import UseContest, {ContestStatus, ContestStatusColor, ContestType, ContestTypeColor} from '../hooks/apis/useContest';
import {Card, List, Space, Tag} from 'antd';
import Flex from '../components/Flex';
import {useMount} from 'react-use';
import CommonApiErrorHandler from '../utils/HttpInstance';
import useQuickRouter from '../utils/QuickRouter';

export default function IndexPage() {
  const listContestState = UseContest.list();
  const quickRouter = useQuickRouter();
  useMount(() => {
    listContestState.request({}).catch(CommonApiErrorHandler);
  });
  return (
    <Flex justify={'center'}>
      <Card title={'活动列表'} loading={listContestState.loading} style={{width: 500}}>
        <List
          style={{marginTop: -10}}
          dataSource={listContestState.data}
          renderItem={item => (
            <List.Item>
              <div>
                <a onClick={() => quickRouter.contestDetail(item.id)}>
                  <h2 style={{marginBottom: 0}}>{item.name}</h2>
                </a>
                <Space>
                  <Tag color={ContestStatusColor[item.status]}>{ContestStatus[item.status]}</Tag>
                  <Tag color={ContestTypeColor[item.status]}>{ContestType[item.type]}</Tag>
                </Space>
              </div>
            </List.Item>
          )}
        />
      </Card>
    </Flex>
  );
}
